import React from 'react';
import './Button.css';

/**
 * Button component with shadcn-like variants
 * 
 * @param {Object} props
 * @param {'default' | 'outline' | 'ghost' | 'link' | 'destructive'} props.variant
 * @param {'default' | 'sm' | 'lg' | 'icon'} props.size
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.disabled
 * @param {React.ReactNode} props.children
 */
const Button = React.forwardRef(({
    variant = 'default',
    size = 'default',
    className = '',
    children,
    disabled,
    type = 'button',
    ...props
}, ref) => {
    const classNames = [
        'btn',
        `btn-${variant}`,
        `btn-size-${size}`,
        disabled ? 'btn-disabled' : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <button
            ref={ref}
            type={type}
            className={classNames}
            disabled={disabled}
            {...props}
        >
            {children}
        </button>
    );
});

Button.displayName = 'Button';

export { Button };
